/* nt-fx-topo.js: cabecalho da home nova (carregado pelo theme.liquid so com body.nt-fx).
   no celular a gaveta do menu vira uma folha curta com um veu por cima da pagina (nt-fx-topo.css): tocar no veu
   fecha, e o tab fica preso na folha e no botao menu da barra de baixo enquanto ela esta aberta.
   abrir, fechar com esc e levar o foco ao primeiro link continuam no nt-mobile.js */
(function () {
  'use strict';
  if (window.ntFxTopo) return;
  window.ntFxTopo = true;

  var gaveta = document.querySelector('details.nt-drawer');
  if (!gaveta) return;
  var painel = gaveta.querySelector('.nt-drawer__panel');

  /* o veu e o proprio details aberto: um toque fora da folha cai nele */
  gaveta.addEventListener('click', function (e) {
    if (e.target === gaveta && gaveta.open) gaveta.open = false;
  });

  function visivel(el) {
    return el.getClientRects().length > 0;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !gaveta.open || !painel || !visivel(painel)) return;
    var itens = Array.prototype.filter.call(painel.querySelectorAll('a[href], button:not([disabled])'), visivel);
    var botao = document.querySelector('[data-nt-m-menu]');
    if (botao && visivel(botao)) itens.push(botao);
    if (!itens.length) return;
    /* o botao menu fica no fim da pagina, longe da folha: a ordem do tab e montada aqui */
    var i = itens.indexOf(document.activeElement);
    var proximo = i === -1 ? (e.shiftKey ? itens.length - 1 : 0) : (i + (e.shiftKey ? -1 : 1) + itens.length) % itens.length;
    e.preventDefault();
    itens[proximo].focus();
  });
})();
